export default __webpack_public_path__ + "ecb851d6d7629bb47c1d41eb230c95cc.svg";